<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 15</h1>
          <div class="text-left">
            <p>Brought a shirt on Savile Row with a pocket.  They do not do shirts with pockets but can put them on for you in 5 days to 5 weeks for a price.  Found a shirt 60% off and was 7% of the price of a Harrods one!  Then I went to the shirt makers street.  Found one with a pocket but at £385 was a bit much for a shirt.</p>
            <a href="/uk/14TowerOfLondon.jpeg"><img alt="Tower of London" class="uitk-image-media" src="14TowerOfLondon.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/14TowerBridge.jpeg"><img alt="Tower Bridge" class="uitk-image-media" src="14TowerBridge.jpeg" style="width: 17%; height: auto;"></a>    
            <p>Windsor castle, you just have to walk through Hyde Park which is a 40 minute walk it turns out.  Not worth it just go to Buckingham Palace it is a 10 minute walk each way.</p>
            <p>Hyde Park.</p>
            <a href="/uk/15HydePark.jpeg"><img alt="Hyde Park" class="uitk-image-media" src="15HydePark.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/15HydePark2.jpg"><img alt="Hyde Park" class="uitk-image-media" src="15HydePark2.jpg" style="width: 17%; height: auto;"></a>    
            <p>Buckingham Palace</p>
            <a href="/uk/15BuckinghamPalace.jpeg"><img alt="Buckingham Palace" class="uitk-image-media" src="15BuckinghamPalace.jpeg" style="width: 17%; height: auto;"></a>    
            <a href="/uk/15BuckinghamPalace2.jpeg"><img alt="Buckingham Palace" class="uitk-image-media" src="15BuckinghamPalace2.jpeg" style="width: 17%; height: auto;"></a>    
            <p>Went to 3 casinos and they were as bad if not worse than the Busan ones.  No money was gambled in a UK casino, pub or TAB.  Grocery and convenience stores took £40 for UK lottery.</p>
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
      ////
    }
  }
  </script>